import { createPlugin } from '@backstage/core-plugin-api';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import {
  rootRouteRef,
  createTechdocsRootRef,
  createTechdocsReaderPageRef,
  createScaffolderSelectedTemplatePageRef,
} from './routes';
import { RelatedLinksCard } from './components/RelatedLinksCard';
import { RecentPageHeader } from './components/RecentPageHeader';
import { MkDocsLayoutStyles } from './components/MkDocsLayoutStyles';

export const Neo4jTechdocsPlugin = createPlugin({
  id: 'neo4j-techdocs',
  routes: {
    root: rootRouteRef,
  },
  externalRoutes: {
    techdocsRoot: createTechdocsRootRef,
    techdocsReaderPage: createTechdocsReaderPageRef,
    scaffolderExecutePage: createScaffolderSelectedTemplatePageRef,
  },
});

// The /docs reader page (ReaderPage) renders these addons. The entity Docs
// tab uses the AddonBlueprint versions in the app techdocsModule.
export const RelatedLinksAddon = Neo4jTechdocsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'RelatedLinks',
    location: TechDocsAddonLocations.SecondarySidebar,
    component: RelatedLinksCard,
  }),
);

export const RecentPageHeaderAddon = Neo4jTechdocsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'RecentPageHeader',
    location: TechDocsAddonLocations.Subheader,
    component: RecentPageHeader,
  }),
);

// Only the /docs reader page renders this addon. The entity Docs tab has no
// docs sidebar, so it keeps the mkdocs navigation.
export const MkDocsLayoutStylesAddon = Neo4jTechdocsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'MkDocsLayoutStyles',
    location: TechDocsAddonLocations.Content,
    component: MkDocsLayoutStyles,
  }),
);
